<template>
    <div class="app-container">
        
    </div>
</template>

<script>
import {
  search_category,
} from "../../api/jounal.js";
export default {
    data(){
        return{
            subject_field:[]
        }
    },
    created(){
        this.GetSearchCategory()
    },
    methods:{
        GetSearchCategory(){
            search_category().then(res=>{
                this.subject_field = res.info_list[4].subject_field
            })
        }
    }
}
</script>

<style>

</style>